import React from "react";
import { cn } from "../../lib/cn";

export function TimelineItem({ children, color = "blue", dot, className }) {
  const ring =
    color === "green"
      ? "ring-brand"
      : color === "gray"
        ? "ring-slate-300"
        : "ring-brand";

  return (
    <li className={cn("relative pb-10 pl-8 last:pb-2", className)}>
      <span
        className={cn(
          "absolute left-[-6px] top-1 flex h-4 w-4 items-center justify-center rounded-full bg-white ring-2",
          ring
        )}
      >
        {dot != null ? (
          <span className="[&_svg]:h-4 [&_svg]:w-4">{dot}</span>
        ) : (
          <span className="h-2 w-2 rounded-full bg-current text-slate-400" />
        )}
      </span>
      <div className="-translate-y-0.5 text-sm">{children}</div>
    </li>
  );
}

export function Timeline({ mode = "start", children, className }) {
  return (
    <ul className={cn("relative ml-3 border-l border-slate-200", className)}>
      {React.Children.map(children, (child) => child)}
    </ul>
  );
}

Timeline.Item = TimelineItem;
